namespace GeniuzPOS.ReportMasterData {
    export namespace PermissionKeys {
        export const Report = "";

        namespace Report_1101 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19:\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32:View";
        }

        namespace Report_1102 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19:\u0E23\u0E32\u0E04\u0E32\u0E02\u0E32\u0E22:View";
        }

        namespace Report_1103 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19:\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E17\u0E35\u0E22\u0E1A\u0E23\u0E32\u0E04\u0E32\u0E17\u0E38\u0E19:View";
        }

        namespace Report_1104 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19:\u0E1C\u0E39\u0E49\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22:View";
        }

        namespace Report_1106 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19:\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32:View";
        }

        namespace Report_1201 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19\u0E02\u0E32\u0E22:\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19\u0E02\u0E32\u0E22:View";
        }

        namespace Report_Shiftcontorl {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19\u0E02\u0E32\u0E22:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E30\u0E41\u0E04\u0E0A\u0E40\u0E0A\u0E35\u0E22\u0E23\u0E4C:View";
        }

        namespace Report_1202 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19\u0E02\u0E32\u0E22:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35\u0E40\u0E15\u0E47\u0E21\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A:View";
        }

        namespace Report_1203 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19\u0E02\u0E32\u0E22:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E2A\u0E23\u0E38\u0E1B\u0E1B\u0E34\u0E14\u0E23\u0E2D\u0E1A\u0E41\u0E04\u0E0A\u0E40\u0E0A\u0E35\u0E22\u0E23\u0E4C:View";
        }

        namespace Report_1301 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E2A\u0E23\u0E38\u0E1B\u0E22\u0E2D\u0E14\u0E02\u0E32\u0E22:\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19:\u0E41\u0E22\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32:View";
        }

        namespace Report_1400 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E2A\u0E23\u0E38\u0E1B\u0E22\u0E2D\u0E14\u0E02\u0E32\u0E22:\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19:\u0E22\u0E2D\u0E14\u0E02\u0E32\u0E22\u0E23\u0E27\u0E21\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32:View";
        }

        namespace Report_1500 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E2A\u0E23\u0E38\u0E1B\u0E22\u0E2D\u0E14\u0E02\u0E32\u0E22:\u0E23\u0E32\u0E22\u0E40\u0E14\u0E37\u0E2D\u0E19:\u0E22\u0E2D\u0E14\u0E02\u0E32\u0E22\u0E23\u0E27\u0E21\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32:View";
        }

        namespace Report_1601_1 {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E2A\u0E23\u0E38\u0E1B\u0E22\u0E2D\u0E14\u0E02\u0E32\u0E22:\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1D\u0E32\u0E01\u0E02\u0E32\u0E22:View";
        }

        namespace Report_1500N {
            export const View = "1POSBASE:\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19:\u0E40\u0E1B\u0E23\u0E35\u0E22\u0E1A\u0E40\u0E17\u0E35\u0E22\u0E1A:\u0E22\u0E2D\u0E14\u0E02\u0E32\u0E22\u0E23\u0E32\u0E22\u0E40\u0E14\u0E37\u0E2D\u0E19:View";
        }
    }
}
